type Props = {
  value: string
  onChange: (s: string) => void
}

export function VerifyDialogCommentSection({ value, onChange }: Props) {
  return (
    <div className="space-y-1">
      <label className="text-xs font-medium text-slate-600">Komentarz (min 3 znaki)</label>
      <textarea
        value={value}
        onChange={e => onChange(e.target.value)}
        maxLength={2000}
        rows={4}
        className="w-full rounded border border-slate-300 p-2 text-sm focus:border-emerald-500 focus:outline-none"
        placeholder="Wyjaśnij, na jakiej podstawie zatwierdzasz wartość pola..."
      />
      <p className="text-xs text-slate-400">{value.length}/2000</p>
    </div>
  )
}
